import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteNeuropsychologicDiagnosticPrescriptionMutation as useChDeleteMeasLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/neuropsychologic-diagnostic-prescription/ch/services/__generated__/useChDeleteNeuropsychologicDiagnosticPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChDeleteNeuropsychologicDiagnosticPrescriptionMutation(
    $input: Ch_deleteNeuropsychologicDiagnosticPrescriptionInput!
  ) {
    ch_deleteNeuropsychologicDiagnosticPrescription(input: $input) {
      ch_NeuropsychologicDiagnosticPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteNeuropsychologicDiagnosticPrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteMeasLaboratoryPrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteMeasLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteNeuropsychologicDiagnosticPrescriptionMutation }
